import en_US from './en_US.json'
import es_US from './es_US.json'
import ta_IN from './ta_IN.json'
export default {
  en_US,
  es_US,
  ta_IN,
}



// WEBPACK FOOTER //
// ./src/locales/index.js